module.exports = __webpack_public_path__ + "static/speaker4-3097987051d42aa61cf018b13c77b76c.jpg";